import { IController } from "../interfaces/controller";

export class ContactUsController implements IController {
    // private container: JQuery;

    constructor() {
        return;
    }

    public render(container: JQuery): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        // this.container = container;
        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    }
    public appRouterID(params: any): string {

        return "contactUs";
    }

    public title(): string {
        return "Contact Us";
    }

    public subTitle(): string {
        return "";
    }
    public haveFieldsChanged(): boolean {
        return false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/contactUs.ts